import { createContext } from 'react'

export type ColorMode = 'light' | 'dark'

/** Ponto de origem do reveal circular (coordenadas do clique que trocou o tema). */
export interface RevealOrigin {
  x: number
  y: number
}

export interface ColorModeContextValue {
  mode: ColorMode
  setMode: (mode: ColorMode, origin?: RevealOrigin) => void
  toggle: (origin?: RevealOrigin) => void
}

export const ColorModeContext = createContext<ColorModeContextValue | null>(null)

export const THEME_STORAGE_KEY = 'transgraos.theme'
export const DEFAULT_MODE: ColorMode = 'light'
